import React from 'react';
import { Typography } from '@mui/material';

function Dashboard() {
  return (
    <>
      <Typography>Dashboard</Typography>
    </>
  )
}

export default Dashboard
